import React, { useState, useEffect, useRef } from "react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import "swiper/swiper-bundle.css";
import anime from "animejs";
import { apiCall, mediaUrl } from "../util";
import { newsAndEvent } from "../Image";
import "swiper/css/autoplay";
import axios from "axios";
import { Link } from "react-router-dom";
const NewsAndEvents = () => {
  const [hoverIndex, setHoverIndex] = useState(null);
  const [data, setData] = useState([]);
  const [titleData, setTitleData] = useState(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    const fetchNewsData = async () => {
      try {
        const response = await axios.post(apiCall + "news/getall");
        setData(response.data.filter((item) => item.isView === 1));
        const result = await axios.post(apiCall + "newstitle/getall");
        if (result.data[0]) {
          setTitleData(result.data[0]);
        }
      } catch (error) {
        console.error("Error fetching news data:", error);
      }
    };
    fetchNewsData();
  }, []);

  useEffect(() => {
    anime({
      targets: ".anime-prev-next",
      translateX: [30, 0],
      opacity: [0, 1],
      duration: 800,
      delay: anime.stagger(150),
      easing: "easeOutQuad",
    });
  }, []);

  return (
    <section className="bg-sg-linen overflow-hidden">
      <div className="container">
        {/* Header Section */}
        <div className="row align-items-center justify-content-between mb-40px">
          <div className="col-xl-5 col-lg-6 md-mb-20px d-flex gap-2 align-items-end">
            <ScrollAnimation
              animateIn="animate__fadeInLeft"
              duration={0.8}
              animateOnce={true}
            >
              <div className="d-flex align-items-center gap-3">
                {" "}
                {/* Flex container */}
                <img src={newsAndEvent} className="w-60px" alt="News Icon" />
                <div>
                  <span className="text-base-color fw-600 lh-1 text-uppercase d-block fs-12">
                    Our Latest
                  </span>
                  <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
                    News and Events
                  </h4>
                </div>
              </div>
            </ScrollAnimation>
          </div>
          <div className="col-xl-5 col-lg-5 last-paragraph-no-margin md-mb-30px">
            <ScrollAnimation
              animateIn="animate__fadeInRight"
              duration={0.8}
              animateOnce={true}
            >
              <p
                className="w-90 xl-w-100 md-w-80 sm-w-100 md-mx-auto"
              >
                {titleData?.title
                  ? titleData.title
                  : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut dolores ipsum sint alias iste adipisci."}
              </p>
            </ScrollAnimation>
          </div>
          <div className="col-xl-2 col-lg-6 d-flex justify-content-center justify-content-lg-end align-self-end">
            <ScrollAnimation
              animateIn="animate__fadeInRight" // You can change this to any animation you prefer
              duration={0.8}
              animateOnce={true}
            >
              <div
                className="slider-one-slide-prev-1 icon-small swiper-button-prev slider-navigation-style-04 bg-white text-base-color box-shadow-large"
                style={{
                  height: "56px",
                  width: "56px",
                  borderRadius: "50%",
                  position: "relative",
                  bottom: "inherit",
                  left: "0",
                  top: "inherit",
                  transform: "translateY(0)",
                  transition: "0.3s",
                  WebkitTransform: "translateY(0)",
                  WebkitTransition: "0.3s",
                  color: "#222222",
                }}
              >
                <i className="fa-solid fa-arrow-left"></i>
              </div>
            </ScrollAnimation>
            <ScrollAnimation
              animateIn="animate__fadeInRight" // You can change this to any animation you prefer
              duration={0.8}
              animateOnce={true}
            >
              <div
                className="slider-one-slide-next-1 icon-small swiper-button-next slider-navigation-style-04 bg-white text-base-color box-shadow-large"
                style={{
                  height: "56px",
                  width: "56px",
                  borderRadius: "50%",
                  position: "relative",
                  bottom: "inherit",
                  left: "0",
                  top: "inherit",
                  transform: "translateY(0)",
                  transition: "0.3s",
                  WebkitTransform: "translateY(0)",
                  WebkitTransition: "0.3s",
                  color: "#222222",
                }}
              >
                <i className="fa-solid fa-arrow-right"></i>
              </div>
            </ScrollAnimation>
          </div>
        </div>

        {/* Swiper Section */}
        <div className="row align-items-center">
          <div className="col-12 position-relative">
            <ScrollAnimation
              animateIn="animate__fadeIn"
              duration={0.8}
              animateOnce={true}
            >
              <div className="outside-box-right-40 xs-outside-box-right-0">
                {data.length > 0 && (
                  <Swiper
                    modules={[Navigation, Pagination, Autoplay]}
                    slidesPerView={1.2}
                    spaceBetween={28}
                    loop={true}
                    autoplay={{ delay: 2000, disableOnInteraction: false,pauseOnMouseEnter: true, }}
                    navigation={{
                      nextEl: ".swiper-button-next",
                      prevEl: ".swiper-button-prev",
                    }}
                    keyboard={{ enabled: true, onlyInViewport: true }}
                    breakpoints={{
                      1200: { slidesPerView: 5 },
                      992: { slidesPerView: 4 },
                      768: { slidesPerView: 3 },
                      576: { slidesPerView: 2 },
                    }}
                    effect="slide"

                  >
                    {data.map((event, index) => (
                      <SwiperSlide key={index}>
                        <div
                          className="m-0 overflow-hidden position-relative events-border-radius shadow-sm"
                          onMouseEnter={() => setHoverIndex(index)}
                          onMouseLeave={() => setHoverIndex(null)}
                        >
                          <div className="h-200px w-100 overflow-hidden">
                            <img
                              src={`${mediaUrl}/${event.image}`}
                              className="w-100 object-fit-cover"
                              alt={event.title}
                              style={{
                                overflow: "hidden",
                                transition: "transform 0.5s ease-in-out",
                                transform:
                                  hoverIndex === index
                                    ? "scale(1.1)"
                                    : "scale(1)",
                              }}
                            />
                          </div>
                          <div className="h-150px bg-white ps-30px pt-30px pe-30px pb-30px">
                            <h5 className="fs-18 lh-sm text-dark-gray fw-600 mb-5px line-clamp-2">
                              {event.title}
                            </h5>
                            <p className="m-0 line-clamp-2 lh-sm">
                              {event.description}
                            </p>
                          </div>
                          <div className="d-flex align-items-start w-100 h-100 z-index-1 bg-white">
                            <Link to={'/news-and-events'}
                              className="btn btn-md btn-gradient-sg-header d-table d-lg-inline-block sg-border-styled fw-600 pt-10px pb-10px px-4"
                            >
                              Read more
                              <i className="fa-solid fa-angle-right fs-14 text-white"></i>
                            </Link>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                )}
              </div>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsAndEvents;

/////selfuseeffect
// import React, { useState, useEffect } from "react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import { Swiper, SwiperSlide } from "swiper/react";
// import ScrollAnimation from "react-animate-on-scroll";
// import "animate.css/animate.min.css";
// import "swiper/swiper-bundle.css"; // Import Swiper styles
// import anime from "animejs";
// import { apiCall, mediaUrl } from "../util";
// import axios from "axios";
// const NewsAndEvents = () => {
//   const [data, setData] = useState([]);
//   const [titleData, setTitleData] = useState(null);
//   const [hoverIndex, setHoverIndex] = useState(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await axios.post(apiCall + "news/getall");
//         setData(response.data.filter((item) => item.isView === 1)); // Limit to 8 news
//         // console.log(response.data.filter(item => item.isView === 1))
//         const titleResponse = await axios.post(apiCall + "newstitle/getall");
//         if (titleResponse.data && titleResponse.data[0]) {
//           setTitleData(titleResponse.data[0]);
//         }
//         // console.log(titleResponse.data[0])
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };
//     fetchData();
//   }, []);

//   useEffect(() => {
//     anime({
//       targets: ".anime-prev-next",
//       translateX: [30, 0],
//       opacity: [0, 1],
//       duration: 800,
//       delay: anime.stagger(150),
//       easing: "easeOutQuad",
//     });
//   }, []);
//   return (
//     <section className="bg-sg-linen overflow-hidden">
//       <div className="container">
//         {/* Header Section */}
//         <div className="row align-items-center justify-content-between mb-40px">
//           <div className="col-xl-5 col-lg-6 md-mb-20px d-flex gap-2 align-items-end">
//             <ScrollAnimation
//               animateIn="animate__fadeInLeft"
//               duration={0.8}
//               animateOnce={true}
//             >
//               <div className="d-flex align-items-center gap-3">
//                 {" "}
//                 {/* Flex container */}
//                 <img
//                   src={newsAndEvent}
//                   className="w-60px"
//                   alt="News Icon"
//                 />
//                 <div>
//                   <span className="text-base-color fw-600 lh-1 text-uppercase d-block fs-12">
//                     Our Latest
//                   </span>
//                   <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
//                     News and Events
//                   </h4>
//                 </div>
//               </div>
//             </ScrollAnimation>
//           </div>
//           <div className="col-xl-5 col-lg-5 last-paragraph-no-margin md-mb-30px">
//             <ScrollAnimation
//               animateIn="animate__fadeInRight"
//               duration={0.8}
//               animateOnce={true}
//             >
//               <p
//                 className="w-90 xl-w-100 md-w-80 sm-w-100 md-mx-auto"
//                 style={{ textAlign: "justify" }}
//               >
//                 {titleData?.title
//                   ? titleData.title
//                   : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut dolores ipsum sint alias iste adipisci."}
//               </p>
//             </ScrollAnimation>
//           </div>
//           <div className="col-xl-2 col-lg-6 d-flex justify-content-center justify-content-lg-end align-self-end">
//             <ScrollAnimation
//               animateIn="animate__fadeInRight" // You can change this to any animation you prefer
//               duration={0.8}
//               animateOnce={true}
//             >
//               <div
//                 className="slider-one-slide-prev-1 icon-small swiper-button-prev slider-navigation-style-04 bg-white text-base-color box-shadow-large"
//                 style={{
//                   height: "56px",
//                   width: "56px",
//                   borderRadius: "50%",
//                   position: "relative",
//                   bottom: "inherit",
//                   left: "0",
//                   top: "inherit",
//                   transform: "translateY(0)",
//                   transition: "0.3s",
//                   WebkitTransform: "translateY(0)",
//                   WebkitTransition: "0.3s",
//                   color: "#222222",
//                 }}
//               >
//                 <i className="fa-solid fa-arrow-left"></i>
//               </div>
//             </ScrollAnimation>
//             <ScrollAnimation
//               animateIn="animate__fadeInRight" // You can change this to any animation you prefer
//               duration={0.8}
//               animateOnce={true}
//             >
//               <div
//                 className="slider-one-slide-next-1 icon-small swiper-button-next slider-navigation-style-04 bg-white text-base-color box-shadow-large"
//                 style={{
//                   height: "56px",
//                   width: "56px",
//                   borderRadius: "50%",
//                   position: "relative",
//                   bottom: "inherit",
//                   left: "0",
//                   top: "inherit",
//                   transform: "translateY(0)",
//                   transition: "0.3s",
//                   WebkitTransform: "translateY(0)",
//                   WebkitTransition: "0.3s",
//                   color: "#222222",
//                 }}
//               >
//                 <i className="fa-solid fa-arrow-right"></i>
//               </div>
//             </ScrollAnimation>
//           </div>
//         </div>

//         {/* Swiper Section */}
//         <div className="row align-items-center">
//           <div className="col-12 position-relative">
//             <ScrollAnimation
//               animateIn="animate__fadeIn"
//               duration={0.8}
//               animateOnce={true}
//             >
//               <div className="outside-box-right-40 xs-outside-box-right-0">
//                 <Swiper
//                   modules={[Navigation, Pagination, Autoplay]}
//                   slidesPerView={1}
//                   spaceBetween={28}
//                   loop={true}
//                   autoplay={{ delay: 2000, disableOnInteraction: false }}
//                   navigation={{
//                     nextEl: ".swiper-button-next",
//                     prevEl: ".swiper-button-prev",
//                   }}
//                   keyboard={{ enabled: true, onlyInViewport: true }}
//                   breakpoints={{
//                     1200: { slidesPerView: 5 },
//                     992: { slidesPerView: 4 },
//                     768: { slidesPerView: 3 },
//                     576: { slidesPerView: 2 },
//                   }}
//                   effect="slide"
//                 >
//                   {data.map((event, index) => (
//                     <SwiperSlide key={index}>
//                       <div
//                         className="m-0 overflow-hidden position-relative events-border-radius shadow-sm"
//                         onMouseEnter={() => setHoverIndex(index)}
//                         onMouseLeave={() => setHoverIndex(null)}
//                       >
//                         <div className="h-200px w-100 overflow-hidden">
//                           <img
//                             src={`${mediaUrl}/${event.image}`}
//                             className="w-100 object-fit-cover"
//                             alt={event.title}
//                             style={{
//                               overflow: "hidden",
//                               transition: "transform 0.5s ease-in-out",
//                               transform:
//                                 hoverIndex === index
//                                   ? "scale(1.1)"
//                                   : "scale(1)",
//                             }}
//                           />
//                         </div>
//                         <div className="h-150px bg-white ps-30px pt-30px pe-30px pb-30px">
//                           <h5 className="fs-18 lh-sm text-dark-gray fw-600 mb-5px line-clamp-2">
//                             {event.title}
//                           </h5>
//                           <p className="m-0 line-clamp-2 lh-sm">
//                             {event.description}
//                           </p>
//                         </div>
//                         <div className="d-flex align-items-start w-100 h-100 z-index-1 bg-white">
//                           <a
//                             href="#"
//                             className="btn btn-md btn-gradient-sg-header d-table d-lg-inline-block sg-border-styled fw-600 pt-10px pb-10px px-4"
//                           >
//                             Read more
//                             <i className="fa-solid fa-angle-right fs-14 text-white"></i>
//                           </a>
//                         </div>
//                       </div>
//                     </SwiperSlide>
//                   ))}
//                 </Swiper>
//               </div>
//             </ScrollAnimation>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default NewsAndEvents;

////animejs
// import React, { useEffect, useState } from "react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import { Swiper, SwiperSlide } from "swiper/react";
// import anime from "animejs";
// import "swiper/swiper-bundle.css";

// const NewsAndEvents = () => {
// useEffect(() => {
//   // Anime.js animations
//   anime({
//     targets: ".anime-target",
//     translateX: [50, 0],
//     opacity: [0, 1],
//     duration: 1200,
//     delay: anime.stagger(150),
//     easing: "easeOutQuad",
//   });

//   anime({
//     targets: ".anime-target-reverse",
//     translateX: [-50, 0],
//     opacity: [0, 1],
//     duration: 1200,
//     delay: anime.stagger(150),
//     easing: "easeOutQuad",
//   });

//   anime({
//     targets: ".swiper-button",
//     translateX: [30, 0],
//     opacity: [0, 1],
//     duration: 800,
//     delay: anime.stagger(150),
//     easing: "easeOutQuad",
//   });

//   anime({
//     targets: ".anime-prev-next",
//     translateX: [30, 0],
//     opacity: [0, 1],
//     duration: 800,
//     delay: anime.stagger(150),
//     easing: "easeOutQuad",
//   });
// }, []);
//   const [hoverIndex, setHoverIndex] = useState(null);
//   return (
//     <section className="bg-sg-linen overflow-hidden">
//       <div className="container">
//         <div className="row align-items-center justify-content-between mb-40px">
//           <div className="col-xl-5 col-lg-6 md-mb-20px d-flex gap-2 align-items-end anime-target">
//             <img
//               src={newsAndEvent}
//               className="w-60px"
//               alt="News Icon"
//             />
//             <div>
//               <span className="text-base-color fw-600 lh-1 text-uppercase d-block fs-12">
//                 Our Latest
//               </span>
//               <h4 className="text-dark-gray fw-bold mb-0 ls-minus-1px">
//                 News and Events
//               </h4>
//             </div>
//           </div>
//           <div className="col-xl-5 col-lg-5 last-paragraph-no-margin md-mb-30px anime-target-reverse">
//             <p className="w-90 xl-w-100 md-w-80 sm-w-100 md-mx-auto">
//               Lorem ipsum dolor sit amet consectetur adipisicing elit. Ut
//               dolores ipsum sint alias iste adipisci.
//             </p>
//           </div>
// <div
//   className="col-xl-2 col-lg-6 d-flex justify-content-center justify-content-lg-end align-self-end anime-prev-next" style={{gap:10}}
// >
//   <div className="slider-one-slide-prev-1 icon-small swiper-button-prev slider-navigation-style-04 bg-white  box-shadow-large"  style={{ height: "56px", width: "56px", borderRadius: "50%", position: "relative", bottom: "inherit", left: "0", top: "inherit", transform: "translateY(0)", transition: "0.3s", WebkitTransform: "translateY(0)", WebkitTransition: "0.3s",color:"#222222" }}>
//     <i className="fa-solid fa-arrow-left"></i>
//   </div>
//   <div className="slider-one-slide-next-1 icon-small swiper-button-next slider-navigation-style-04 bg-white  box-shadow-large" style={{ height: "56px", width: "56px", borderRadius: "50%", position: "relative", bottom: "inherit", left: "0", top: "inherit", transform: "translateY(0)", transition: "0.3s", WebkitTransform: "translateY(0)", WebkitTransition: "0.3s",color:"#222222" }}>
//     <i className="fa-solid fa-arrow-right"></i>
//   </div>
// </div>
//         </div>
//         <div className="row align-items-center">
//           <div className="col-12 position-relative">
//             <div className="outside-box-right-40 xs-outside-box-right-0 anime-target">
//               <Swiper
//                 modules={[Navigation, Pagination, Autoplay]} // Ensure modules are passed correctly
//                 slidesPerView={1.2}
//                 spaceBetween={28}
//                 loop={true}
//                 autoplay={{ delay: 2000, disableOnInteraction: false }} // Set disableOnInteraction to false for continuous autoplay
//                 navigation={{
//                   nextEl: ".swiper-button-next",
//                   prevEl: ".swiper-button-prev",
//                 }}
//                 keyboard={{ enabled: true, onlyInViewport: true }}
//                 breakpoints={{
//                   1200: { slidesPerView: 5 },
//                   992: { slidesPerView: 4 },
//                   768: { slidesPerView: 3 },
//                   576: { slidesPerView: 2 },
//                 }}
//                 effect="slide"
//               >
//                 {[
//                   {
//                     imgSrc: "../assets/gokulam_images/news-1.jpg",
//                     title: "Pain clinic inauguration",
//                     description:
//                       "Time of Inauguration: 10:00 AM Location: Super Speciality Block Inaugurated by: Dr. MANOJAN KK (Vice Chairman)",
//                   },
//                   {
//                     imgSrc: "../assets/gokulam_images/news-3.jpg",
//                     title: "Hearty Congratulations Dr Anu Babu",
//                     description:
//                       "Hearty Congratulations Dr Anu Babu, Associate Professor, Department of General Surgery for receiving MRCS from President, Royal College of Surgery, Edinburgh in July 2024",
//                   },
//                   {
//                     imgSrc: "../assets/gokulam_images/news-2.png",
//                     title:
//                       "NABL Accreditation for the laboratory testing facilities",
//                     description:
//                       "Time of Inauguration: 10:00 AM Location: Super Speciality Block Inaugurated by: Dr. MANOJAN KK (Vice Chairman)",
//                   },
//                   {
//                     imgSrc:
//                       "../assets/gokulam_images/Chairman Sir- J C Daniel1709558806475.jpeg",
//                     title: "Hearty congratulations to our beloved Chairman",
//                     description:
//                       "On receiving the prestigious J C Daniel Foundation Trust Gold Award from Former Minister Kadakampally Surendran, MLA at Bharat Bhavan, Thiruvananthapuram on 26th Feb 2024",
//                   },
//                   {
//                     imgSrc: "../assets/gokulam_images/news-3.jpg",
//                     title: "Hearty Congratulations Dr Anu Babu",
//                     description:
//                       "Hearty Congratulations Dr Anu Babu, Associate Professor, Department of General Surgery for receiving MRCS from President, Royal College of Surgery, Edinburgh in July 2024",
//                   },
//                   {
//                     imgSrc: "../assets/gokulam_images/news-2.png",
//                     title:
//                       "NABL Accreditation for the laboratory testing facilities",
//                     description:
//                       "Time of Inauguration: 10:00 AM Location: Super Speciality Block Inaugurated by: Dr. MANOJAN KK (Vice Chairman)",
//                   },
//                 ].map((event, index) => (
//                   <SwiperSlide key={index}>
//                     <div
//                       className="m-0 overflow-hidden position-relative events-border-radius shadow-sm"

//                       onMouseEnter={() => setHoverIndex(index)}
//                       onMouseLeave={() => setHoverIndex(null)}
//                     >
//                       <div className="h-200px w-100 overflow-hidden">
//                         <img
//                           src={event.imgSrc}
//                           className="w-100 object-fit-cover"
//                           alt={event.title}
//                           style={{
//                             overflow: "hidden",
//                             transition: "transform 0.5s ease-in-out",
//                             transform:
//                               hoverIndex === index ? "scale(1.1)" : "scale(1)",
//                           }}
//                         />
//                       </div>
//                       <div className="h-150px bg-white ps-30px pt-30px pe-30px pb-30px">
//                         <h5 className="fs-18 lh-sm text-dark-gray fw-600 mb-5px line-clamp-2">
//                           {event.title}
//                         </h5>
//                         <p className="m-0 line-clamp-2 lh-sm">
//                           {event.description}
//                         </p>
//                       </div>
//                       <div className="d-flex align-items-start w-100 h-100 z-index-1 bg-white">
//                         <a
//                           href="#"
//                           className="btn btn-md btn-gradient-sg-header d-table d-lg-inline-block sg-border-styled fw-600 pt-10px pb-10px px-4"
//                         >
//                           Read more
//                           <i className="fa-solid fa-angle-right fs-14 text-white"></i>
//                         </a>
//                       </div>
//                     </div>
//                   </SwiperSlide>
//                 ))}
//               </Swiper>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default NewsAndEvents;
